<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
    <p>Switch component</p>
    <docs-section [content]="componentContent"></docs-section>
</demo-section>
  